import { DateTime } from 'luxon';
import { type } from '@mews-framework/utils';

interface DateTimeUtc {
    value: string;
    millis: number;
}

function DateTimeUtc(luxon: DateTime): DateTimeUtc {
    return type.create(DateTimeUtc, {
        value: luxon.toUTC().toISO(),
        millis: luxon.toMillis(),
    });
}

export default DateTimeUtc;
